import styled from 'styled-components'

export const MarginWrapper = styled.div`
  display: flex;
  column-gap: 24px;
  margin-top: 4px;
  margin-left: 211px;
`
